import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offre" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-129" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-130" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-131" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-132" data-mp="tyv5tcf1sfy9">🏆 </span>Offre spéciale de lancement
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-133" data-mp="u0xvtwg7a92z">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-134" data-mp="13x14zm9gz7zf">
            Pack ARTS PRÊT™
          </span>

          <dl data-id="element-135" data-mp="2fbemm9dmqr70">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-136" data-mp="2fe0ygl7jzsv1">
                <dt className="text-ink/80" data-id="element-137" data-mp="pjpdu8g8tctm">{row.label}</dt>
                <dd className="shrink-0 font-bold text-brand" data-id="element-138" data-mp="uisdtehd8suq">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-139" data-mp="zjg6s5p5njrl">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-140" data-mp="13iypqvxf1krs">
                Valeur totale :
              </dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-141" data-mp="6vai57uzdamh">153 €</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-142" data-mp="bqpwe0wwh8jf">
            Aujourd&apos;hui seulement
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-143" data-mp="km5wgzo90jxg">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-144" data-mp="3k7kqaqvpzild">
              🏆
            </span>
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-145" data-mp="3o8whh0u8sbvo">
              19
            </span>
            <span className="self-end pb-2 font-display text-3xl font-black text-brand" data-id="element-146" data-mp="vdwdar3hdqpp">
              €
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-147" data-mp="155afx7qqb6n2">
            <span aria-hidden="true" data-id="element-148" data-mp="106pfp8bh8mym">💳 </span>Paiement sécurisé, traité dans
            votre devise locale (ou l&apos;équivalent de 19 €).
          </p>

          <CtaButton label="Je récupère le Pack ARTS PRÊT™" className="mt-4 w-full" data-id="element-149" data-mp="chej8315teqa" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-150" data-mp="7k4oc7v04av2">
            Accès Immédiat · Paiement Unique · Accès à Vie · Garantie 7 Jours
          </p>
        </div>
      </div>
    </section>;
}